import React from 'react'
export default function Tick(props) {
  return (

    <svg
      className={props.className}
      onClick={props.onClick}
      viewBox="0 0 21 21"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-704.000000, -592.000000)" fillRule="nonzero">
          <g transform="translate(706.708964, 594.870987)">
            <path d="M7.71198845,-1 C5.30623613,-1 3.12823922,-0.0248787172 1.55168026,1.55168023 C-0.0248787089,3.12823918 -1,5.30623608 -1,7.71198839 C-1,10.1177407 -0.0248787089,12.2957376 1.55168026,13.8722965 C3.12823922,15.4488555 5.30623613,16.4239768 7.71198845,16.4239768 C10.1177408,16.4239768 12.2957377,15.4488555 13.8722966,13.8722965 C15.4488556,12.2957376 16.4239769,10.1177407 16.4239769,7.71198839 C16.4239769,5.30623608 15.4488556,3.12823918 13.8722966,1.55168023 C12.2957377,-0.0248787172 10.1177408,-1 7.71198845,-1 Z" stroke="#FFFFFF" strokeWidth="2" fill="#303030"></path>
            <path d="M6.11627688,11.7954078 L2.88221721,8.56134812 C2.68795376,8.36705431 2.68795376,8.05198737 2.88221721,7.85769356 L3.58587177,7.15406937 C3.78016558,6.95977556 4.09523253,6.95977556 4.28952634,7.15406937 L6.46811934,9.33269273 L11.1344506,4.66636155 C11.3287747,4.47203737 11.6438417,4.47203737 11.8381051,4.66636155 L12.5417597,5.36998574 C12.7360231,5.56427955 12.7360231,5.87934649 12.5417597,6.0736403 L6.81996181,11.7954381 C6.62563763,11.9897016 6.31060106,11.9897016 6.11627688,11.7954078 Z" fill="#FFFFFF"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}